export default "__VITE_ASSET__CGLTZXWq__"